
import MapPantalla from '../components/mapaCompleto/mapaCompleto';
const MapaPantalla = () => {
	return (
		<>
			<MapPantalla />
		</>
	);
}

export default MapaPantalla;   